import service from 'service';

export const showOrganization = ({ queryKey: [, uuid] }) => {
  const url = `/core_subscriber/organizations/${uuid}`;
  return service.get(url);
};

export const editRate = ({ uuid, ...payload }) => {
  const url = `core_subscriber/organizations/${uuid}`;
  return service.put(url, payload);
};
export const getOrganizations = ({ queryKey: [, params] }) => {
  const url = `/core_subscriber/organizations`;
  return service.get(url, { params });
};

export const banAccount = ({ uuid, ...payload }) => {
  const url = `core_subscriber/subscribers/${uuid}/organization/ban`;
  return service.put(url, payload);
};

export const banExempt = (uuid) => {
  const url = `core_subscriber/subscribers/${uuid}/organization/ban_exempted`;
  return service.put(url);
};

export const showSubscriberSubscription = ({ queryKey: [, id] }) => {
  const url = `/core_subscriber/subscribers/${id}/subscription`;
  return service.get(url);
};

export const getOrgWallet = ({ queryKey: [, id] }) => {
  const url = `/core_wallet/v1/wallet/${id}`;
  return service.get(url);
};

export const getTotalMsgs = ({ queryKey: [, id] }) => {
  const url = `/core_messaging/v1/subscriber/total/${id}`;
  return service.get(url);
};

export const getTotalInteg = ({ queryKey: [, id] }) => {
  const url = `/core_keys/v1/token/total/${id}`;
  return service.get(url);
};

export const getTotalMasks = ({ queryKey: [, id] }) => {
  const url = `/core_sender/v1/sender_name/total/${id}`;
  return service.get(url);
};

export const getDashboardGraph = ({ queryKey: [, id, params] }) => {
  const url = `/core_messaging/v1/subscriber/graph/${id}`;
  return service.get(url, { params });
};

export const getSubscriberMaskNames = ({ queryKey: [, id, params] }) => {
  const url = `/core_sender/v1/sender_name/subscriber/${id}`;
  return service.get(url, { params });
};

export const getSubscriberIntegrations = ({ queryKey: [, id, params] }) => {
  const url = `/core_keys/v1/token/${id}`;
  return service.get(url, { params });
};

export const getSubscriberUpgradeHistory = ({ queryKey: [, id, params] }) => {
  const url = `/core_subscription/v1/user/${id}`;
  return service.get(url, { params });
};

export const getSubscriberMessages = ({ queryKey: [, id, params] }) => {
  const url = `/core_messaging/v1/subscriber/${id}`;
  return service.get(url, { params });
};

export const getSubscriberTxnHistory = ({ queryKey: [, id, params] }) => {
  const url = `/core_wallet/v1/wallet_ledger/${id}`;
  return service.get(url, { params });
};

export const getSubscriberRateHistory = ({ queryKey: [, id, params] }) => {
  const url = `/core_subscriber/rate_history/${id}`;
  return service.get(url, { params });
};

export const getDomainList = ({ queryKey: [, uuid] }) => {
  const url = `core_messaging/v1/organization/${uuid}/domains`;
  return service.get(url);
};

export const addDomain = ({ uuid, ...payload }) => {
  const url = `core_messaging/v1/organization/${uuid}/domains`;
  return service.post(url, payload);
};

export const editDomain = ({ uuid, domainUuid, ...payload }) => {
  const url = `core_messaging/v1/organization/${uuid}/domains/${domainUuid}`;
  return service.put(url, payload);
};

export const deleteDomain = ({ org, domain }) => {
  const url = `core_messaging/v1/organization/${org}/domains/${domain}`;
  return service.delete(url);
};

export const getOrgBanLogs = ({ queryKey: [, id, params] }) => {
  const url = `/core_subscriber/organizations/${id}/ban_logs`;
  return service.get(url, { params });
};
